
<template>
<a-form-model-item
    :label="scene === warehouseType.out?'提货人手机':'联系人手机'"
    :colon="false"
    :prop="propStr"
    :rules="ruleStation?[]:phone.RULES"
    :label-col="{span: 6}"
    :wrapper-col="{span: 18}"
>
    <a-input
        v-if="!ruleStation || isLine"
    :value="contactPhone"
    :max-length="phone.MAX_LENGTH"
    :placeholder="scene === warehouseType.out?'请输入提货人手机':'请输入联系人手机'"
    :disabled="disabled"
    @change="onChange" />
  <div v-else>{{ruleStation.ext.telPhone}}</div>
</a-form-model-item>
</template>

<script>
import FormValidator from '@/constants/formValidator'
import {tabListType} from "@/pages/orderManage/constant";
import minix from './minix'

const warehouseType = {
  in: 'STORE',
  out: 'DELIVER'
}
export default {
    mixins: [minix],
    model: {
        prop: 'contactPhone',
        event: 'change'
    },
    props: {
        contactPhone: {
            type: String,
            required: true
        },
        propName: {
            type: String,
            default: 'contactPhone'
        },
        disabled: {
            type: Boolean,
            default: false
        },
      ruleStation:{
          type:Object
        },
      isLine: {
        type: Boolean
      },
      scene: {
        type: String,
        default: ''
      },
      tab:{
        type:String,
        default: tabListType.WAREHOUSE
      }
    },
    data () {
        return {
          warehouseType,
            phone: FormValidator.Phone
        }
    },
    methods: {
        onChange({target}) {
            this.$emit('change', target.value)
        }
    },
}
</script>
